import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { Component, Input, OnInit,Inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import{NotesHelper} from '@app/_core/helper/NotesHelper';
@Component({
  selector: 'app-case-change-history',
  templateUrl: './case-change-history.component.html',
  styleUrls: ['./case-change-history.component.scss'],
})
export class CaseChangeHistoryComponent implements OnInit {
  lists: any;
  @Input()
  ChangeArray: any;
  @Input()
  Heading: any;

  constructor(public bsModalRef: BsModalRef,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private sanitizer: DomSanitizer,private _notes:NotesHelper) {}

  ngOnInit(): void { 
    this.formatChangeSet();
  }
  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
  }   
  getSafeHtml(value: string | null | undefined): SafeHtml {
     const decoded = this.decodeEntities(value); 
    return this.sanitizer.bypassSecurityTrustHtml(value || '');
  }
  
  /**
   * Decodes HTML entities in a string safely without XSS vulnerabilities.
   * SECURITY: Uses textContent instead of innerHTML to prevent script injection.
   * @param value - String containing HTML entities to decode
   * @returns Decoded string with HTML entities converted to characters
   */
  decodeEntities(value: string | null | undefined): string {
    const t = document.createElement('textarea');
    // SECURITY: Use textContent instead of innerHTML to prevent XSS attacks
    t.textContent = value || '';
    return t.value;
  }
 formatChangeSet(): void {
  this.ChangeArray = this.ChangeArray?.map(item => ({
    ...item,
    Changes: item.Changes?.map(change => {
      const processValue = (val: string) =>
        this._notes.isHtmlContent(val)
          ? this._notes.parsefromString(val)
          : val;

      return {
        ...change,
        PreviousValue: processValue(change.PreviousValue),
        Value: processValue(change.Value)
      };
    })
  }));
}

  isHtmlContent(value: string | null | undefined): boolean { 
    return this._notes.isHtmlContent(value);
  }

}
